import React from 'react';
import { motion } from 'framer-motion';
import '../styles/OilGas.css';

import { IoCheckmark } from "react-icons/io5";
// import { IoCheckmark } from 'react-icons/io';

const fadeLeft = {
  hidden: { opacity: 0, x: -40 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.7 } }
};
const fadeRight = {
  hidden: { opacity: 0, x: 40 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.7 } }
};
const fadeUp = {
  hidden: { opacity: 0, filter: 'blur(8px)' },
  visible: { opacity: 1, filter: 'blur(0)', transition: { duration: 1 } }
};

const OilGas = () => (
  <div className="oilgas-bg">
    <div className="oilgas-hero-img-wrap">
      <motion.div
        className="oilgas-hero-img"
        initial="hidden"
        animate="visible"
        variants={fadeUp}
      >
        {/* <img src="../../Images/drilling-rig.webp" alt="Offshore Oil Rig" /> */}
        <div className="oilgas-hero-overlay">
          <h1>Oil &amp; Gas Exploration</h1>
          <p>Unlocking Nigeria's Offshore Potential Through Precision Exploration</p>
        </div>
      </motion.div>
    </div>
    <div className="container oilgas-container">
      {/* Intro Section */}

      {/* Graphs Section */}
      {/* <motion.section
        className="oilgas-graphs-section"
        variants={fadeRight}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
      >
        <div className="oilgas-graphs-grid">
          <div className="oilgas-graph-card">
            <img src="../../Images/Screenshot (51).png" alt="GGOEX’s Three Business Pillars Market Size & Growth" />
            <div className="oilgas-graph-label">GGOEX’s Three Business Pillars Market Size &amp; Growth</div>
          </div>
          <div className="oilgas-graph-card">
            <img src="../../Images/Screenshot (52).png" alt="West Africa Energy Investment by Sector (2025–2030)" />
            <div className="oilgas-graph-label">West Africa Energy Investment by Sector (2025–2030)</div>
          </div>
        </div>
      </motion.section> */}

      {/* Strategic Asset Portfolio */}
      <motion.section
        className="oilgas-section oilgas-alt-bg"
        variants={fadeLeft}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
      >
        <h3>Strategic Asset Portfolio</h3>
        <p className="oilgas-justify">
          GGOEX is on the verge of managing a substantial gas reserve with over <strong>3.3 trillion cubic feet (TCF)</strong> of certified gas reserves and <strong>600 million barrels (MMbbl)</strong> of condensate. Operations will be primarily concentrated within <strong>2 mature offshore blocks</strong> in Nigeria to capitalize on the country’s significant natural gas potential.
        </p>
        <p className="oilgas-justify">
          Our reserves are independently certified by <strong>Ryder Scott</strong>, a globally recognized petroleum reserves certification provider, ensuring reliability and compliance with international financial and regulatory standards.
        </p>
      </motion.section>

      {/* Current Operations */}
      <motion.section
        className="oilgas-section"
        variants={fadeRight}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
      >
        <h3>Current Operations</h3>
        <p className="oilgas-justify">
          GGOEX is advancing a comprehensive <strong>10-well drilling campaign</strong> covering:
        </p>
        <ul className="oilgas-bullet-list">
          <li><IoCheckmark color='blue' />  Gas wells for primary production</li>
          <li><IoCheckmark color='blue' />  Condensate wells for liquid recovery</li>
          <li><IoCheckmark color='blue' />  Water disposal wells for environmental compliance</li>
        </ul>
        <p className="oilgas-justify">
          This diversified strategy improves both resource efficiency and environmental responsibility across offshore operations.
        </p>
      </motion.section>

      {/* Environmental & Regulatory Compliance */}
      <motion.section
        className="oilgas-section oilgas-alt-bg"
        variants={fadeLeft}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
      >
        <h3>Environmental &amp; Regulatory Compliance</h3>
        <p className="oilgas-justify">
          The company operates with zero-flare design and environmental monitoring systems. This aligns with Nigeria’s 2030 routine gas flaring elimination goal.
        </p>
        <p className="oilgas-justify">
          It complies with Petroleum Industry Act (PIA) 2021 via NUPRC oversight 35% local content policy via the Nigerian Content Development and Monitoring Board (NCDMB)
        </p>
        {/* <ul className="oilgas-bullet-list">
          <li><IoCheckmark color='blue' />  </li>
          <li><IoCheckmark color='blue' />  </li>
        </ul> */}
        <p className="oilgas-justify">
          Initiatives include training Nigerian geoscientists in reservoir modeling.
        </p>
      </motion.section>

      {/* Table Section */}
      {/* <motion.section
        className="oilgas-section-card"
        variants={fadeRight}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
      >
        <h3>Exploration Metrics</h3>
        <div className="oilgas-table-card">
          <table className="oilgas-table">
            <tbody>
              <tr>
                <th>Certified Gas Reserves</th>
                <td>3.3 TCF</td>
              </tr>
              <tr>
                <th>Condensate Resources</th>
                <td>600 MMbbl</td>
              </tr>
              <tr>
                <th>Drill Types</th>
                <td>Gas, Condensate, Water</td>
              </tr>
              <tr>
                <th>Local Content Compliance</th>
                <td>35%</td>
              </tr>
              <tr>
                <th>Regulator</th>
                <td>NUPRC</td>
              </tr>
              <tr>
                <th>Certification Provider</th>
                <td>Ryder Scott</td>
              </tr>
              <tr>
                <th>First Gas Target</th>
                <td>Q2 2026</td>
              </tr>
            </tbody>
          </table>
        </div>
      </motion.section> */}
    </div>
  </div>
);

export default OilGas;